/* Copyright (c) 2026 Health Endeavors, LLC. All Rights Reserved */

export const InfoIcon = () => {
  return (
    <svg
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="info-icon-svg"
    >
      <path
        d="M8 16.5927C3.58173 16.5927 0.00020726 12.8786 6.99349e-07 8.29675C1.08562e-06 3.71471 3.5816 -0.000123196 8 -0.000122796C12.4184 -0.000122395 16 3.71471 16 8.29675C15.9998 12.8786 12.4183 16.5927 8 16.5927ZM8 14.9335C11.5288 14.9334 14.3994 11.9552 14.3994 8.29578C14.3992 4.63651 11.5286 1.65911 8 1.65906C4.47134 1.65906 1.59983 4.63647 1.59961 8.29578C1.59961 11.9553 4.4712 14.9335 8 14.9335ZM8 5.80749C7.5584 5.80749 7.2002 5.43537 7.2002 4.97742C7.20043 4.51967 7.55855 4.14831 8 4.14831C8.44136 4.14842 8.79957 4.51974 8.79981 4.97742C8.79981 5.4353 8.44151 5.80738 8 5.80749ZM8 12.4442C7.5584 12.4442 7.2002 12.0721 7.2002 11.6141L7.2002 7.46667C7.20032 7.00883 7.55848 6.6366 8 6.6366C8.44144 6.63671 8.79968 7.00889 8.79981 7.46667L8.79981 11.6141C8.79981 12.072 8.44151 12.4441 8 12.4442Z"
        fill="#D4D3FF"
      />
    </svg>
  );
};
